export default {"src":"/_next/static/media/battery-bolt.ee7d2d31.svg","height":800,"width":800};